<template>
	<div class="centerWidth">
		<div class="gaokao">
			<!-- <div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>学生学情档案</span>
			</div> -->
			<section class="gaokao-content">
				<div class="my-title">学生学情档案</div>
				<article class="fenNum_head flex zhong center xieqDiv">
					<p class="on">
						<i></i>
						<span>基本信息</span>
					</p>
					<p class="on">
						<i></i>
						<span>成绩信息</span>
					</p>
					<p class="on">
						<i></i>
						<span>综合信息</span>
					</p>
					<p class="on">
						<i></i>
						<span>偏爱方向</span>
					</p>
				</article>
				<article class="general-content">
					<div class="from-c01">
						<p>你的优势学科是什么：</p>
						<input placeholder="请输入你的优势学科" v-model="AdvantageousDisciplines" />
					</div>
					<div class="from-c01">
						<p>你的薄弱学科是什么：</p>
						<input placeholder="请输入你的薄弱学科" v-model="WeakSubjects" />
					</div>
					<div class="from-c01">
						<p>学生爱好及特长(获奖证书等)：</p>
						<input placeholder="请输入爱好及特长" v-model="AwardCertificate" />
					</div>
					<div class="from-c01">
						<p>喜爱专业：</p>
						<input placeholder="请输入喜爱专业" v-model="LoveProfessional" />
					</div>
					<div class="from-c01">
						<p>发展方向(毕业后考研、出国、工作)：</p>
						<input placeholder="请输入发展方向" v-model="DevelopmentDirection" />
					</div>
					<div class="from-c01">
						<p>你有意向的院校吗：</p>
						<input placeholder="请输入意向的院校" v-model="IntendedInstitutions" />
					</div>
					<div class="from-c01">
						<p>你有意向的城市吗：</p>
						<input placeholder="请输入意向的城市" v-model="IntendedCity" />
					</div>
					<div class="from-c01">
						<p>孩子喜欢专业：</p>
						<input placeholder="请输入孩子喜欢专业" v-model="LikeProfessional" />
					</div>
					<div class="from-c01">
						<p>家长推荐专业：</p>
						<input placeholder="请输入推荐专业" v-model="RecommendedMajor" />
					</div>
					<div class="from-c01">
						<p>家长其他考虑: (如人脉资源、孩子身体状况等)：</p>
						<input placeholder="请输入其他考虑" v-model="OtherConsiderations" />
					</div>
				</article>
				<div class="test-btn">
					<button class="gaokao-btn" @click="goTestc()">上一步</button>
					<button class="gaokao-btn" @click="goTestd()">确定</button>
				</div>
			</section>
		</div>

		<div class="popup flex zhong center" v-show="IsShow">
			<div class="xiu_center">
				<h6>提交成功</h6>
				<div class="xiu_info">
					<p>
						系统将自动跳转
						<span>[我的报告]</span>
						，跳转后点击
						<span>[查看报告]</span>
					</p>
					<p>马上了解你的学情档案报告吧!</p>
				</div>
				<div class="xiu_bg">
					<div class="xiu_btn flex zhong center"><button type="button" @click="returnMy()">确定</button></div>
				</div>
			</div>
		</div>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-if="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	export default {
		data() {
			return {
				isJiaIng: false,
				key: '',
				IsShow: false,
				sid: 0,
				IsCke: true,
				AdvantageousDisciplines: '',
				WeakSubjects: '',
				AwardCertificate: '',
				LoveProfessional: '',
				DevelopmentDirection: '',
				IntendedInstitutions: '',
				IntendedCity: '',
				LikeProfessional: '',
				RecommendedMajor: '',
				OtherConsiderations: ''
			};
		},
		// 加载
		created() {
			var that = this;
			that.sid = that.$route.query.sid;
			that.key = Cookies.get('fileindex_key');
		},
		mounted() {
			this.drawLineB();
		},
		methods: {
			drawLineB() {
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: '75%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: [{
							value: 1048,
							name: ''
						}, {
							value: 735,
							name: ''
						}]
					}]
				});
			},
			// 上一步
			goTestc() {
				this.$router.push({
					path: '/general',
					query: {
						sid: this.sid
					}
				});
			},
			// 确定
			goTestd() {
				var that = this;
				if (!that.IsCke) {
					return;
				}
				// if (that.AdvantageousDisciplines.length === 0) {
				// 	that.$util.showError('请输入优势学科');
				// 	return false;
				// }
				// if (that.WeakSubjects.length === 0) {
				// 	that.$util.showError('请输入薄弱学科');
				// 	return false;
				// }
				// if (that.AwardCertificate.length === 0) {
				// 	that.$util.showError('请输入获奖证书');
				// 	return false;
				// }
				// if (that.LoveProfessional.length === 0) {
				// 	that.$util.showError('请输入喜爱专业');
				// 	return false;
				// }
				// if (that.DevelopmentDirection.length === 0) {
				// 	that.$util.showError('请输入发展方向');
				// 	return false;
				// }
				// if (that.IntendedInstitutions.length === 0) {
				// 	that.$util.showError('请输入意向院校');
				// 	return false;
				// }
				// if (that.IntendedCity.length === 0) {
				// 	that.$util.showError('请输入意向城市');
				// 	return false;
				// }
				// if (that.LikeProfessional.length === 0) {
				// 	that.$util.showError('请输入喜欢专业');
				// 	return false;
				// }
				// if (that.RecommendedMajor.length === 0) {
				// 	that.$util.showError('请输入推荐专业');
				// 	return false;
				// }
				// if (that.OtherConsiderations.length === 0) {
				// 	that.$util.showError('请输入其他考虑');
				// 	return false;
				// }

				that.IsCke = false;
				const loading = this.$loading({
					lock: true
				});
				that.$api.HtppRequest(
					'SystemData/InsertStudentsLove',
					'POST', {
						SAR_Id: that.sid,
						AdvantageousDisciplines: that.AdvantageousDisciplines,
						WeakSubjects: that.WeakSubjects,
						AwardCertificate: that.AwardCertificate,
						LoveProfessional: that.LoveProfessional,
						DevelopmentDirection: that.DevelopmentDirection,
						IntendedInstitutions: that.IntendedInstitutions,
						IntendedCity: that.IntendedCity,
						LikeProfessional: that.LikeProfessional,
						RecommendedMajor: that.RecommendedMajor,
						OtherConsiderations: that.OtherConsiderations,
						Id: 0
					},
					function(res) {
						loading.close();
						console.log('添加', res);

						if (res.flag) {
							// 弹窗
							that.IsShow = true;
							that.$api.reduceUserCount({
								key: that.key
							});
						}
						that.IsCke = true;
					},
					function(err) {
						loading.close();
						console.log(err);
						that.IsCke = true;
					}
				);
			},
			returnMy() {
				this.$router.push('/service');
			}
		}
	};
</script>

<style scoped>
	.xiu_info {
		padding: 40px 0;
	}

	.xiu_info p:last-child {
		margin-top: 30px;
	}

	.xiu_info p {
		font-size: 16px;
		color: #333;
		text-align: center;
	}

	.xiu_info p span {
		color: #333;
		cursor: pointer;
	}

	.xiu_btn button {
		width: 100px;
		height: 44px;
		line-height: 44px;
		font-size: 16px;
		margin: 0 30px;
		color: #fff;
		border-radius: 4px;
		background-color: #333;
		cursor: pointer;
	}

	.xiu_bg {
		padding: 40px 80px;
	}

	.xiu_center h6 {
		font-size: 16px;
		background-color: #333;
		color: #fff;
		text-align: center;
		line-height: 44px;
	}

	.xiu_center {
		width: 600px;
		background-color: #fff;
	}

	.gaokao {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	.fenNum_head {
		margin-top: 20px;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	/* general-content */
	.general-content {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin-top: 40px;
	}

	.from-c01 {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 10px;
	}

	.from-c01:last-child {
		margin-bottom: 0px;
	}

	.from-c01 p {
		width: 30%;
		font-size: 15px;
		color: #333;
		text-align: right;
	}

	.from-c01 input {
		width: 300px;
		height: 40px;
		line-height: 38px;
		padding: 0 10px;
		border: 1px solid #eee;
		border-radius: 4px;
		font-size: 15px;
		color: #333;
	}

	.from-c01 input::-webkit-input-placeholder {
		color: #999;
	}

	.from-c01 input:-moz-placeholder {
		color: #999;
	}

	.from-c01 input:-ms-input-placeholder {
		color: #999;
	}

	.from-ipt {
		width: 130px;
	}

	.from-ctxt {
		font-size: 15px;
		color: #333;
		padding: 0 10px;
	}

	.test-btn {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.test-btn button {
		margin-left: 20px;
		margin-right: 20px;
	}

	.gaokao-btn {
		width: 200px;
		height: 40px;
		background-color: #333;
		border-radius: 6px;
		font-size: 16px;
		color: #fff;
		line-height: 40px;
		margin: 50px auto;
		display: block;
	}
</style>
